<template>
  <div class="shared-link-restore-file">

    <el-card class="restore-file-container">
      <div class="restore-file-header">
        <el-icon
          class="el-sidebar-icon"
          :name="getLinkRestoreInfo.displayName | fileIcon()"/>
      </div>

      <div class="restore-file-body">

        <div class="el-text el-text--subheading">
          {{ getLinkRestoreInfo.displayName }}
        </div>

        <div class="mt-24 el-text el-text--caption">
          <span style="color: #828489;">
            {{ $t('shared-link.restore-file.label.size') }}
          </span>
          {{ getLinkRestoreInfo.size | size }}
        </div>

        <div class="mt-24">
          <el-button
            @click="onRestore()"
            style="width: 100%;"
          >
            {{ $t('shared-link.restore-file.button.restore') }}
          </el-button>
        </div>

      </div>

    </el-card>

  </div>
</template>

<style lang="scss" scoped>
  .shared-link-restore-file {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }

  .restore-file-container {
    margin-top: -78px;
    min-width: 288px;
  }

  .restore-file-header {
    text-align: center;
    margin-top: 40px;
  }

  .restore-file-body {
    margin: 48px 24px 96px;
  }
</style>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  FETCH_LINK_RESTORE_INFO
} from '../store/action-types';

import {
  PENDING_STATUS
} from '../store/action-status';

const { mapGetters, mapActions } = createNamespacedHelpers('shared-link');

export default {
  name: 'SharedLinkRestoreFile',
  data: function () {
    return {
      fileName: '',
      fullScreenLoader: ''
    };
  },
  computed: {
    ...mapGetters([
      'getLinkCipher',
      'getLinkPassword',
      'getLinkRestoreInfo',
      'getFetchLinkRestoreInfoStatus'
    ])
  },
  watch: {
    getFetchLinkRestoreInfoStatus(status) {
      if (status === PENDING_STATUS) {
        this.showLoading();
      } else {
        this.hideLoading();
      }
    }
  },
  methods: {
    ...mapActions({
      fetchLinkRestoreInfo: FETCH_LINK_RESTORE_INFO
    }),
    onRestore() {
      this.$emit('restore', '');
    },
    showLoading() {
      this.fullScreenLoader = this.$loading({
        background: 'fixed-modal',
        color: 'fixed-white',
        size: '48',
        lock: true
      });
    },
    hideLoading() {
      if (this.fullScreenLoader !== '') {
        this.fullScreenLoader.close();
      }
    },
    init() {
      this.fetchLinkRestoreInfo({
        linkCipher: this.getLinkCipher,
        password: this.getLinkPassword
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
